export const GET_PATIENT_APPOINTMENTS = "GET_PATIENT_APPOINTMENTS";
export type GET_PATIENT_APPOINTMENTS = typeof GET_PATIENT_APPOINTMENTS;

export const POST_CONFIRM_APPOINTMENT = "POST_CONFIRM_APPOINTMENT";
export type POST_CONFIRM_APPOINTMENT = typeof POST_CONFIRM_APPOINTMENT;



// WEBPACK FOOTER //
// ./src/sagas/Appointments/constant.ts